// extracted by mini-css-extract-plugin
export default {"inspector":"styles_inspector__dcvtH","error":"styles_error__nLxy7"};